import { render, staticRenderFns } from "./Geofencing.vue?vue&type=template&id=318e6084&scoped=true"
import script from "./Geofencing.vue?vue&type=script&lang=js"
export * from "./Geofencing.vue?vue&type=script&lang=js"
import style0 from "./Geofencing.vue?vue&type=style&index=0&id=318e6084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318e6084",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GlobalDrawerList: require('/home/vsts/work/1/s/components/global/DrawerList.vue').default})
